/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Activity_Type_TaskInputs */

const vi_work_activity_type_task = /** @type {(inputs: Work_Activity_Type_TaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhiệm vụ`)
};

/**

* @param {Work_Activity_Type_TaskInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const work_activity_type_task = /** @type {((inputs?: Work_Activity_Type_TaskInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Activity_Type_TaskInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_work_activity_type_task(inputs)
});